import ComingSoon from "@/components/ComingSoon";

export default function PolitiqueConfidentialite() {
    return (
        <ComingSoon
            testid="privacy-page"
            title="Politique de confidentialité"
            hint="Le détail du traitement des données personnelles et des cookies sera publié ici très prochainement."
        />
    );
}
